const isAndroid = (): boolean => /android/i.test(navigator.userAgent);

const isPromptRequired = async (name: PermissionName): Promise<boolean> => {
  if (!navigator.permissions) {
    return true;
  }

  try {
    const permission = await navigator.permissions.query({ name });

    return permission.state === 'prompt';
  } catch {
    return true;
  }
};

export const warmUpCapturePermission = async (): Promise<void> => {
  if (!isAndroid() || !navigator.mediaDevices) {
    return;
  }

  const [isCameraPromptRequired, isMicrophonePromptRequired] =
    await Promise.all([
      isPromptRequired('camera' as PermissionName),
      isPromptRequired('microphone' as PermissionName),
    ]);

  if (!isCameraPromptRequired && !isMicrophonePromptRequired) {
    return;
  }

  const stream = await navigator.mediaDevices
    .getUserMedia({
      video: isCameraPromptRequired,
      audio: isMicrophonePromptRequired,
    })
    .catch(() => null);

  stream?.getTracks().forEach((track) => track.stop());
};
